import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './HeroSection.css';
import './HeroSectionMobile.css';

const HeroSection: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  const techIcons = [
    { name: 'Robotics', icon: '🤖', color: '#6366f1' },
    { name: 'AI', icon: '🧠', color: '#3b82f6' },
    { name: 'IoT', icon: '🌐', color: '#ec4899' },
    { name: 'Drone Tech', icon: '🚁', color: '#10b981' },
    { name: 'Aero Modelling', icon: '✈️', color: '#f59e0b' }
  ];

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className={`hero-section ${isVisible ? 'visible' : ''}`}>
      <div className="hero-background">
        <div className="gradient-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="badge">
              <div className="badge-content">
                <span className="badge-icon">🚀</span>
                <span className="badge-text">IIITD-IC Summer Camp 2026 · 21–31 May</span>
              </div>
            </div>
            
            <h1 className="hero-title">
              <span className="title-word">Where Young</span>
              <span className="title-word">Innovators</span>
              <span className="title-word">Take Flight!</span>
            </h1>
            
            <p className="hero-description">
              Unlock your child's potential and spark their curiosity with the latest in technology. 
              At our immersive IIITD-IC Summer Camp 2026, kids dive into the exciting worlds of Robotics,
              Artificial Intelligence, Internet of Things (IoT), Drone Technology, and Aero Modelling 
              — all designed to inspire creativity and build real-world skills.
            </p>
            
            <div className="cta-buttons">
              <Link to="/register" className="btn btn-primary">
                <span>Register Now</span>
                <span className="btn-icon">→</span>
              </Link>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="floating-cards">
              <div className="card card-1">
                <div className="card-content">
                  <h3>Hands-on Projects</h3>
                  <p>Learn by building real-world applications</p>
                </div>
              </div>
              <div className="card card-2">
                <div className="card-content">
                  <h3>Expert Mentors</h3>
                  <p>Learn from industry professionals</p>
                </div>
              </div>
              <div className="card card-3">
                <div className="card-content">
                  <h3>Future Skills</h3>
                  <p>Master in-demand technologies</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="tech-stack">
          <p className="tech-label">Explore our cutting-edge tracks:</p>
          <div className="tech-icons">
            {techIcons.map((tech, index) => (
              <div 
                key={index} 
                className="tech-icon"
                style={{ '--icon-color': tech.color } as React.CSSProperties}
              >
                <div className="icon-circle">
                  <span className="icon">{tech.icon}</span>
                </div>
                <span className="icon-label">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
